module.exports = __webpack_public_path__ + "img/settinghelp.52aca1ab.png";